export default "__VITE_ASSET__WKm8RwRE__"